import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import type { ActionProps } from "./actions.types";

import s from "./action.module.scss";

const Action = ({
  label,
  icon,
  className = "link-lemon",
  wrapperClassName,
  iconProps,
  onClick
}: ActionProps) => {
  return (
    <div className={`${s.buttons} ${wrapperClassName}`}>
      <button
        className={`link ${className}`}
        aria-label={label}
        onClick={onClick}
      >
        {icon && (
          <FontAwesomeIcon
            className="link-icon-left"
            data-testid="icon"
            icon={icon}
            {...iconProps}
          />
        )}
        <span>{label}</span>
      </button>
    </div>
  );
};

export default Action;
